import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Este proyecto nunca ha registrado un service worker propio, pero si algún
// visitante llegó a cargar una versión anterior que sí lo hacía (plantilla
// original), ese worker se queda instalado en su teléfono para siempre y
// sigue sirviendo esa versión vieja cacheada -- sin importar lo que se
// despliegue después, el navegador nunca vuelve a pedir nada nuevo (pantalla
// en blanco si esa versión vieja referencia archivos que ya no existen).
// Se desinstala solo, de forma silenciosa, si llega a encontrar alguno.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  }).catch(() => {});
  if (window.caches) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
